<jmkw-button
  [iconName]="locationIconName()"
  [active]="isActive()"
  (click)="onClick($event)"
  [tooltipText]="tooltipText"
>
</jmkw-button>
